import { Font } from '@react-pdf/renderer';

// Registers Montserrat with @react-pdf so <Text> can resolve weights 400-700.
// .ttf files live in ui/public/fonts/montserrat/ and are served at /fonts/...
// by both the dev server and CloudFront in production.
//
// Disable hyphenation — Montserrat with @react-pdf's default Knuth-Plass
// hyphenator produces awkward mid-word breaks in our short, list-heavy copy.
let registered = false;

export function registerFonts() {
  if (registered) return;
  registered = true;

  Font.register({
    family: 'Montserrat',
    fonts: [
      { src: '/fonts/montserrat/Montserrat-Regular.ttf',  fontWeight: 400 },
      { src: '/fonts/montserrat/Montserrat-Medium.ttf',   fontWeight: 500 },
      { src: '/fonts/montserrat/Montserrat-MediumItalic.ttf', fontWeight: 500, fontStyle: 'italic' },
      { src: '/fonts/montserrat/Montserrat-SemiBold.ttf', fontWeight: 600 },
      { src: '/fonts/montserrat/Montserrat-Bold.ttf',     fontWeight: 700 },
    ],
  });

  Font.registerHyphenationCallback(word => [word]);
}
